/**
 * Discreet banner that warns when the FX rates table is older than the
 * configured TTL (24h by default). Only renders when the backend reports
 * `stale=true`, so on normal days the user sees nothing.
 */
import { AlertTriangle } from "lucide-react";
import { useFxRates } from "../hooks/queries";
import { useLang } from "../contexts/LangContext";
import { tx } from "../i18n";

export function FxStaleBanner() {
  const { lang } = useLang();
  const { data } = useFxRates();
  if (!data?.stale) return null;
  const fetchedLabel = data.fetched_at
    ? new Date(data.fetched_at).toLocaleString()
    : (tx(lang, "never", "nunca", "nunca"));
  return (
    <div
      data-testid="fx-stale-banner"
      className="px-3 py-1.5 bg-amber-50 border-b border-amber-200 text-amber-800 text-[11px] font-medium flex items-center gap-1.5 justify-center"
    >
      <AlertTriangle className="h-3 w-3 shrink-0" />
      {tx(lang, `FX rates are stale (last synced: ${fetchedLabel}). Conversions may not reflect the live value.`, `Tipos de cambio desactualizados (última sincronización: ${fetchedLabel}). Las conversiones pueden no reflejar el valor real.`, `Tipos de cambio desactualizados (última sincronización: ${fetchedLabel}). Las conversiones pueden no reflejar el valor real.`)}
    </div>
  );
}
